import React from 'react';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';

const values = [
    { name: "Top 5", value: 5, previousValue: 0 },
    { name: "Top 10", value: 10, previousValue: 5 },
    { name: "Top 15", value: 15, previousValue: 10 },
    { name: "Top 20", value: 20, previousValue: 15 },
    { name: "Top 25", value: 25, previousValue: 20 },
    { name: "Top 50", value: 50, previousValue: 25 },
    { name: "Top 100", value: 100, previousValue: 100 },
    { name: "Show All", value: 0, previousValue: 0 },
];
export default function LimitGroupBy(props) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    let { totalCount = 0 } = props;

    // totalCount = totalCount <= 10 ? 10 : totalCount;

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const getNameFromValue = (value) => {
        if (value == 0) {
            return "Limit";
        }
        let item = values.find(item => item.value == value) || { 'name': 'Limit' }

        return item.name;
    }

    const valuesFiltered = values.filter(val => {
        return val.value <= totalCount || totalCount > val.previousValue
    })

    return (
        <div>
            <Button
                aria-haspopup="true"
                onClick={handleClick}
                variant="contained"
                color="primary"
            >
                {getNameFromValue(props.value)}
            </Button>
            {/* <IconButton
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={handleClick}
            >
                <MoreVertIcon />
            </IconButton> */}
            <Menu
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                {valuesFiltered.map((value) =>
                    <MenuItem
                        onClick={() => {
                            props.onChange(value.value);
                            handleClose();
                        }
                        }>{value.value == 0 ? value.name + " ( " + props.totalCount + " )" : value.name}
                    </MenuItem>)}
            </Menu>
        </div>
    );
}